import React, { useEffect } from 'react';
import { Col, Row } from '@design-system-etat/dsfr-react';
import PropTypes from 'prop-types';
import { getAPI } from 'store/apiReducer';
import { connect } from 'react-redux';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
    CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
} from '../../../../constants/apiUrls.constants';
import TableauMunition from './TableauMunition';

const Munitions = ({ getApi, formattedData }) => {
    useEffect(() => {
        getApi(
            usagerClientReducer,
            API_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
            CONTEXT_GET_RECHERCHE_ARMES_QUOTA_MUNITIONS,
        );
    }, []);

    return (
        <>
            <Row gutters>
                <Col col={12}>{formattedData && <TableauMunition munitions={formattedData} />}</Col>
            </Row>
        </>
    );
};

Munitions.propTypes = {
    getApi: PropTypes.func.isRequired,
    formattedData: PropTypes.shape({
        nombreTotal: PropTypes.number.isRequired,
        records: PropTypes.array,
    }),
};

const formaterAffichageDate = (date) => {
    return new Date(date).toLocaleDateString('fr-FR');
};

const formaterAffichageDateMoinsUnAn = (date) => {
    const dateMoinsUnAn = new Date(date);
    dateMoinsUnAn.setFullYear(dateMoinsUnAn.getFullYear() - 1);
    return dateMoinsUnAn.toLocaleDateString('fr-FR');
};

const formaterAffichageMunitions = (data) => {
    /* eslint-disable no-param-reassign */
    if (data) {
        const formattedData = JSON.parse(JSON.stringify(data));
        formattedData.records.forEach((record) => {
            record.periodeQuota = record.dateFinMunition
                ? `${formaterAffichageDateMoinsUnAn(
                      record.dateFinMunition,
                  )} - ${formaterAffichageDate(record.dateFinMunition)}`
                : ``;
            record.dateMiseEnStock = record.dateMiseEnStock
                ? formaterAffichageDate(record.dateMiseEnStock)
                : formaterAffichageDate(record.dateInit);
            record.quotaUtiliseMunition = record.quotaUtiliseMunition ?? 0;
        });
        return formattedData;
    }
    return data;
};

export default connect(
    (state) => {
        const { data } = state.recherche.armesQuotaMunitions;
        const formattedData = formaterAffichageMunitions(data);
        return {
            formattedData,
        };
    },
    {
        getApi: getAPI,
    },
)(Munitions);
